import config from './website-config';

export const authorProfileUrl = `${config.siteUrl}/author/darlene-stott/`;

export const authorPerson = {
  '@type': 'Person',
  '@id': `${authorProfileUrl}#person`,
  name: 'Darlene Stott',
  jobTitle: 'Managing Editor',
  url: authorProfileUrl,
};

export const publisherOrganization = {
  '@type': 'Organization',
  name: 'Giggster',
  url: 'https://giggster.com/',
  slogan: 'A better way to book locations',
  sameAs: ['https://www.instagram.com/giggster_official/', 'https://www.facebook.com/giggsterHQ/'],
  logo: {
    '@type': 'ImageObject',
    url: 'https://giggster.com/static/images/logo.svg',
  },
};

interface ArticleSchemaOptions {
  headline: string;
  description?: string;
  url: string;
  image?: string;
  datePublished?: string;
}

export function articleSchema(options: ArticleSchemaOptions) {
  const schema: { [key: string]: any } = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: options.headline,
    url: options.url,
    author: authorPerson,
    publisher: publisherOrganization,
  };
  if (options.description) {
    schema.description = options.description;
  }
  if (options.image) {
    schema.image = options.image;
  }
  if (options.datePublished) {
    schema.datePublished = options.datePublished;
  }
  return schema;
}

interface CollectionPageSchemaOptions {
  name: string;
  description?: string;
  url: string;
}

export function collectionPageSchema(options: CollectionPageSchemaOptions) {
  const schema: { [key: string]: any } = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: options.name,
    url: options.url,
    author: authorPerson,
    publisher: publisherOrganization,
  };
  if (options.description) {
    schema.description = options.description;
  }
  return schema;
}
